import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { datadogRum } from '@datadog/browser-rum';
import { environment } from './environments/environment';
import { version } from '../package.json';

function initDatadogRum(): void {
  const appVersion: string = version;
  const applicationId = environment.dd_app_id?.trim();
  const clientToken = environment.dd_client_token?.trim();

  if (!applicationId || !clientToken) {
    if (environment.production) {
      console.warn('Datadog RUM not initialized: missing app id or client token.');
    }
    return;
  }

  datadogRum.init({
    applicationId,
    clientToken,
    site: 'datadoghq.eu',
    service: 'web-app',
    env: environment.dd_env,
    version: appVersion,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input',
  });
}

initDatadogRum();

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
